import 'react-international-phone/style.css';
import './index.css';
import { createEndionChatbot, updateChatbotContext, updateChatbotState } from './endion-chatbot.tsx';
import { ENDION_CHATBOT_READY_EVENT_NAME } from './utils/events.ts';

window.endion = {
  ...(window.endion || {}),
  createEndionChatbot,
  updateChatbotContext,
  updateChatbotState,
};

// Send a custom window event for outer scripts to listen.
document.dispatchEvent(
  new CustomEvent(ENDION_CHATBOT_READY_EVENT_NAME, {
    bubbles: true,
    cancelable: true,
    detail: {
      ...window.endion,
    },
  }),
);

if (import.meta.env.DEV) {
  const chatbotApiKey = import.meta.env.VITE_DEV_ENDION_API_KEY ?? '';
  createEndionChatbot({
    chatbotApiKey,
    automaticRemount: true,
    endion_debug: {
      simulatedOrigin: import.meta.env.VITE_DEV_SIMULATED_ORIGIN,
    },
    context: {
      realEstate: {
        propertyId: import.meta.env.VITE_DEV_REAL_ESTATE_PROPERTY_ID,
        developmentId: import.meta.env.VITE_DEV_REAL_ESTATE_DEVELOPMENT_ID,
      },
    },
  });
} else {
  const currentScript = document.currentScript;

  if (currentScript) {
    const { dataset } = currentScript;
    // TODO: Define dataset schema
    const {
      mountElementSelector,
      initialize,
      chatbotApiKey = '',
      automaticRemount,
      context = '{}',
      showTrigger,
    } = dataset;

    // TODO: Parse with zod (or any lightweight alternative)
    let parsedContext = {};
    try {
      parsedContext = JSON.parse(context);
    } catch (e) {
      console.error('Endion Chatbot: initial context is malformed', parsedContext);
    }

    if (initialize === 'true') {
      createEndionChatbot({
        chatbotApiKey,
        automaticRemount: (automaticRemount || '').toLowerCase() === 'false' ? false : true,
        mountElement: mountElementSelector ? document.querySelector<HTMLElement>(mountElementSelector) : null,
        endion_debug: {},
        context: parsedContext,
        showTrigger: (showTrigger || '').toLowerCase() === 'false' ? false : true,
      });
    }
  }
}
